import { StyledDigitSlot } from './TabularNums.Styled'

type Props = {
  value: string
}

// Fallback for `font-variant-numeric: tabular-nums` - the Google Fonts Poppins
// subset ships without the `tnum` OpenType feature, so each digit is rendered
// in a fixed-width slot instead.
export const TabularNums = ({ value }: Props) => {
  return (
    <>
      {Array.from(value).map((char, index) =>
        /\d/.test(char) ? (
          <StyledDigitSlot key={index}>{char}</StyledDigitSlot>
        ) : (
          char
        )
      )}
    </>
  )
}
